import { db } from "@/firebaseConfig";

const menuGroupCollection = db.collection("menu_group");

const saveMenuGroup = async (id, data) => {
  menuGroupCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("MenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateMenuGroup = async (id, data) => {
  menuGroupCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("MenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteMenuGroup = async id => {
  menuGroupCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("MenuGroup successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getMenuGroupById = async id => {
  return menuGroupCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  menuGroupCollection,
  saveMenuGroup,
  updateMenuGroup,
  deleteMenuGroup,
  getMenuGroupById
};
